import { render, staticRenderFns } from "./ContactWidget.vue?vue&type=template&id=0f4ffece&scoped=true&"
import script from "./ContactWidget.vue?vue&type=script&lang=js&"
export * from "./ContactWidget.vue?vue&type=script&lang=js&"
import style0 from "./ContactWidget.vue?vue&type=style&index=0&id=0f4ffece&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4ffece",
  null
  
)

export default component.exports